import React, { useCallback, useContext } from 'react'

import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import PriceRowPriceDetails from 'LuxKit/PricePoints/PriceRowPriceDetails'
import Clickable from 'components/Common/Clickable'
import IncludesTaxesAndFeesDetails from 'components/Search/Hotels/IncludesTaxesAndFeeDetails'
import ModalContext from 'contexts/ModalContext'

import type { PriceDetailsModalOfferProps } from './PriceDetailsModal'
import PriceDetailsModal from './PriceDetailsModal'

type Props = {
  offerPage?: boolean
  duration: number
  taxesAndFees?: number
  propertyFees?: number
  /** The price **without property fees** */
  hotelPrice: number
  /** The member price **without property fees** */
  hotelMemberPrice?: number
  showMemberPrice?: boolean
  flightPrice?: number
  otherFees?: {
    propertyFees: number
    extraGuestsSurcharge: number
  }
  rooms?: Array<App.Occupants>
  extraGuestMessage?: string
  dueAtPropertyMessage?: string
  propertiesFees?: Array<App.PropertyFeesDetails>
  cta?: React.ReactNode
  onCtaAfterClose?: () => void
  context?: 'search'
  hasMobilePromotion?: boolean
  hideIncludesTaxesAndFees?: boolean
  hasRelatedPayAtPropertyRate?: boolean
  discount?: number
  rateId?: string
  /** When provided with checkOut and rooms, used for commission fetch so modal matches row context (e.g. tour accommodation). */
  checkIn?: string
  checkOut?: string
} & PriceDetailsModalOfferProps & ({
  trigger: 'price-row'
  triggerSize: 'M' | 'L'
} | {
  trigger: 'info-icon'
  triggerSize?: undefined
})

function OfferPriceDetailsRow(props: Props) {
  const {
    trigger,
    triggerSize,
    context,
    hideIncludesTaxesAndFees = false,
    ...modalProps
  } = props

  const showModal = useContext(ModalContext)

  const openModal = useCallback(async() => {
    const result = await showModal<'fine-print' | undefined>(<PriceDetailsModal
      {...modalProps}
    />)

    if (result === 'fine-print') {
      window.location.href = '#fine-print'
    }
  }, [modalProps, showModal])

  return (
    <>
      {trigger === 'price-row' && context === 'search' && !hideIncludesTaxesAndFees &&
        <IncludesTaxesAndFeesDetails size={triggerSize} onClick={openModal} />}
      {trigger === 'price-row' && context !== 'search' && <PriceRowPriceDetails size={triggerSize} onClick={openModal} />}
      {trigger === 'info-icon' && <Clickable onClick={openModal}><LineInfoCircleIcon /></Clickable>}
    </>
  )
}

export default OfferPriceDetailsRow
